<template>
  <div class="relative w-full ">
    <input
      type="radio"
      :name="name"
      :id="id"
      class="hidden form__input"
      :value="value"
      :checked="value === modelValue"
      @change="$emit('update:modelValue', value)"
    />
    <label
      :for="id"
      class="flex cursor-pointer items-center rounded-xl bg-white p-4 text-xs font-medium text-gray-900 shadow transition-all"
      :style="fixedHeight ? 'height: 52px' : ''"
      >
      <slot name="icon"></slot>
      <span class="pointer-events-none select-none">
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "FormRadio",

  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    modelValue: {
      // The v-model prop should be named 'modelValue'
      type: String,
      required: true,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
